import { motion } from "framer-motion";
import { ChevronDown, Home } from "lucide-react";

interface ScrollToBottomButtonProps {
  show: boolean;
  onScrollToBottom: () => void;
  onScrollToTop: () => void;
}

export function ScrollToBottomButton({
  show,
  onScrollToBottom,
  onScrollToTop,
}: ScrollToBottomButtonProps) {
  if (!show) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      className="fixed bottom-20 right-4 z-30 flex flex-col items-end gap-2 sm:bottom-6 sm:right-6"
    >
      {/* Scroll to top button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={onScrollToTop}
        className="flex h-10 w-10 items-center justify-center rounded-md border border-white/10 bg-[#1b1c22] text-white/60 shadow-lg shadow-black/25 transition-colors hover:bg-[#23242b] hover:text-white"
        aria-label="Scroll to top"
        title="Scroll to top"
      >
        <Home size={19} />
      </motion.button>

      {/* Scroll to bottom button */}
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={onScrollToBottom}
        className="flex h-11 w-11 items-center justify-center rounded-md bg-[#FD954F] font-bold text-[#1C1C1E] shadow-lg shadow-black/25 transition-colors hover:bg-[#F28747]"
        aria-label="Scroll to bottom"
        title="Scroll to bottom"
      >
        <ChevronDown size={22} />
      </motion.button>
    </motion.div>
  );
}
